import { render, staticRenderFns } from "./CollectionsGroup.vue?vue&type=template&id=6d4e3ab4&scoped=true&"
import script from "./CollectionsGroup.vue?vue&type=script&lang=js&"
export * from "./CollectionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsGroup.vue?vue&type=style&index=0&id=6d4e3ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e3ab4",
  null
  
)

export default component.exports